import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/index.css';
import { BrowserRouter } from "react-router-dom";

import App from './App';

//added the react-router package and wrap the entire app using the browserrouter

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

